// extracted by mini-css-extract-plugin
export default {"pageWrap":"Va-z","fullWidth":"Wa-z","heading":"Xa-z","fullBleed":"Ya-z","hidden":"Za-z"};